import { Center, Loader } from "@mantine/core";
import { Plugin, RenderViewer, Viewer } from "@react-pdf-viewer/core";
import { thumbnailPlugin } from "@react-pdf-viewer/thumbnail";
import { memo } from "react";

interface PageThumbnailPluginProps {
  PageThumbnail: React.ReactElement;
}

const THUMBNAIL_WIDTH = 1200;

const pageThumbnailPlugin = (props: PageThumbnailPluginProps): Plugin => {
  const { PageThumbnail } = props;

  return {
    renderViewer: (renderProps: RenderViewer) => {
      let { slot } = renderProps;

      slot.children = PageThumbnail;

      if (slot.subSlot) {
        slot.attrs = {};
        slot.subSlot.children = <></>;
      }

      return slot;
    },
  };
};
const PdfPreview = ({ preview }: { preview: string }) => {
  const thumbnailPluginInstance = thumbnailPlugin({
    renderSpinner: () => (
      <Center mih={400}>
        <Loader />
      </Center>
    ),
    thumbnailWidth: THUMBNAIL_WIDTH,
  });
  const { Cover } = thumbnailPluginInstance;

  const pageThumbnailPluginInstance = pageThumbnailPlugin({
    PageThumbnail: <Cover width={THUMBNAIL_WIDTH} getPageIndex={() => 0} />,
  });

  return (
    <Viewer
      fileUrl={preview}
      plugins={[pageThumbnailPluginInstance, thumbnailPluginInstance]}
      renderLoader={() => <></>}
    />
  );
};

export default memo(PdfPreview);
